import {FC, useEffect, useState, useRef} from 'react'
import {Link} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import {useAuth} from '../../modules/auth'
import {getUserByToken} from '../../modules/auth/core/_requests'
import {useNavigate} from 'react-router-dom'
// import {getPosts} from '../blog/_requests'
// import {PostModel} from '../blog/BlogModels'
// import {BlogCard} from '../blog/BlogCard'
import {Helmet} from 'react-helmet-async'

const Index: FC = () => {
  const intl = useIntl()
  const didRequest = useRef(false)
  const {setCurrentUser, saveAuth} = useAuth()
  const navigate = useNavigate()
  const heroRef = useRef<HTMLElement>(null)
  const [tilt, setTilt] = useState({x: 0, y: 0})
  const rafRef = useRef<number | null>(null)
  // const [latestPosts, setLatestPosts] = useState<PostModel[]>([])
  // const [loadingPosts, setLoadingPosts] = useState(false)
  // const [errorPosts, setErrorPosts] = useState<string | null>(null)

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        if (didRequest.current) return
        didRequest.current = true
        const params = new URLSearchParams(window.location.search)
        const token = params.get('token')
        if (token) {
          const tokenAuth = {api_token: token, status: true}
          saveAuth(tokenAuth)
          const {data: user} = await getUserByToken()
          if (user) {
            setCurrentUser(user)
            navigate('/dashboard', {replace: true})
          }
        }
      } catch {
        /**/
      }
    }
    const fetchLatestPosts = async () => {
      // setLoadingPosts(true)
      // setErrorPosts(null)
      // try {
      //   const response = await getPosts('latest')
      //   setLatestPosts(Array.isArray(response.data) ? response.data.slice(0, 3) : [])
      // } catch (e) {
      //   setErrorPosts(intl.formatMessage({id: 'LANDING.BLOG.ERROR'}))
      // } finally {
      //   setLoadingPosts(false)
      // }
    }
    initializeAuth()
    // fetchLatestPosts()
  }, [saveAuth, setCurrentUser])

  const handleHeroMouseMove = (e: React.MouseEvent<HTMLElement>) => {
    if (!heroRef.current) return
    if (rafRef.current) cancelAnimationFrame(rafRef.current)
    rafRef.current = requestAnimationFrame(() => {
      const rect = heroRef.current!.getBoundingClientRect()
      const w = rect.width
      const h = rect.height
      const x = (e.clientX - rect.left) / w
      const y = (e.clientY - rect.top) / h
      const maxMove = 24
      const moveX = (x - 0.5) * 2 * maxMove
      const moveY = (y - 0.5) * 2 * maxMove
      setTilt({x: moveX, y: moveY})
      rafRef.current = null
    })
  }

  const handleHeroMouseLeave = () => {
    setTilt({x: 0, y: 0})
  }

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({id: 'LANDING.META.TITLE'})}</title>
        <meta
          name='description'
          content={intl.formatMessage({id: 'LANDING.META.DESC'})}
        />
        <meta
          property='og:title'
          content={intl.formatMessage({id: 'LANDING.META.TITLE'})}
        />
        <meta
          property='og:description'
          content={intl.formatMessage({id: 'LANDING.META.DESC'})}
        />
      </Helmet>
      {/* Hero Section */}
      <section
        id='hero-section'
        ref={heroRef}
        className='hero-section mt-2 contact-hero'
        onMouseMove={handleHeroMouseMove}
        onMouseLeave={handleHeroMouseLeave}
      >
        <div className='hero-content'>
          <div className='mb-4'>
            <span className='badge px-4 py-2 rounded-pill'>
              <KTIcon iconName='star' className='fs-2 text-warning ms-2' />
              {intl.formatMessage({id: 'LANDING.HERO.BADGE'})}
            </span>
          </div>
          <h1 className='hero-title'>
            {intl.formatMessage({id: 'LANDING.HERO.TITLE'})} <span className='hero-brand'>{intl.formatMessage({id: 'LANDING.HERO.BRAND'})}</span>،
            <br />
            {intl.formatMessage({id: 'LANDING.HERO.TITLE_LINE2'})}
          </h1>
          <p className='hero-desc'>
            {intl.formatMessage({id: 'LANDING.HERO.SUBTITLE'})}
          </p>
          <div className='hero-action'>
            <Link
              to='/auth/registration'
              className='custom-btn btn-custom-font btn-custom-color rounded-pill btn-lg px-7 me-2'
            >
              {intl.formatMessage({id: 'LANDING.HERO.CTA'})}
            </Link>
          </div>
        </div>
        <div
          className='hero-image'
          style={{
            transform: `translate(${tilt.x}px, ${tilt.y}px)`,
            transition: 'transform 0.2s ease-out',
          }}
        >
          <img src={toAbsoluteUrl('/media/illustrations/energy/Final.png')} alt={intl.formatMessage({id: 'LANDING.HERO.IMG_ALT'})} />
        </div>
        <button
          className='hero-scroll-btn'
          onClick={() => {
            const nextSection = document.getElementById('first-content-section')
            if (nextSection) nextSection.scrollIntoView({behavior: 'smooth'})
          }}
          aria-label={intl.formatMessage({id: 'COMMON.SCROLL_DOWN'})}
        >
          <svg
            className='hero-scroll-svg'
            width='120'
            height='64'
            viewBox='0 0 120 64'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M88.0935 28C88.0935 12.536 75.3811 0 59.6996 0C44.0181 0 31.3057 12.536 31.3057 28C31.3057 43.464 44.0181 56 59.6996 56C75.3811 56 88.0935 43.464 88.0935 28Z'
              fill='#F1F1F3'
            ></path>
            <path
              d='M39.5969 8.86421C32.3121 15.6129 24.4015 27.5594 4.6961 27.8366C-15.0093 28.1137 33.673 39.7129 33.673 39.7129C33.673 39.7129 46.8818 2.11406 39.5969 8.86421Z'
              fill='#F1F1F3'
            ></path>
            <path
              d='M80.4024 8.86412C86.625 16.1764 95.5975 27.5595 115.304 27.8366C135.01 28.1138 86.3273 39.7129 86.3273 39.7129C86.3273 39.7129 74.1798 1.55253 80.4024 8.86412Z'
              fill='#F1F1F3'
            ></path>
            <path
              d='M54.6667 22.3334L60 27.6667L65.3334 22.3334'
              stroke='#19191A'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            ></path>
          </svg>
        </button>
      </section>

      {/* begin::markets Section */}
      <section id='first-content-section' className='service-highlights-section'>
        <div className='container'>
          <div className='text-center mb-6'>
            <h2 className='mb-3 section-title'>{intl.formatMessage({id: 'LANDING.MARKETS.TITLE'})}</h2>
            <p className='text-gray-600 text-center fs-5 section-desc'>
              {intl.formatMessage({id: 'LANDING.MARKETS.DESC'})}
            </p>
          </div>
          <div className='row g-4 g-md-5 justify-content-center'>
            <div className='col-lg-4 col-md-6 col-12'>
              <div className='service-card'>
                <div className='service-icon'>
                  <img
                    src={toAbsoluteUrl('/media/illustrations/energy/forexNew.png')}
                    alt={intl.formatMessage({id: 'LANDING.MARKETS.FOREX_TITLE'})}
                  />
                </div>
                <h5 className='service-title'>{intl.formatMessage({id: 'LANDING.MARKETS.FOREX_TITLE'})}</h5>
                <p className='service-description'>
                  {intl.formatMessage({id: 'LANDING.MARKETS.FOREX_DESC'})}
                </p>
              </div>
            </div>
            <div className='col-lg-4 col-md-6 col-12'>
              <div className='service-card'>
                <div className='service-icon'>
                  <img
                    src={toAbsoluteUrl('/media/illustrations/energy/indicesNew.png')}
                    alt={intl.formatMessage({id: 'LANDING.MARKETS.INDICES_TITLE'})}
                  />
                </div>
                <h5 className='service-title'>{intl.formatMessage({id: 'LANDING.MARKETS.INDICES_TITLE'})}</h5>
                <p className='service-description'>
                  {intl.formatMessage({id: 'LANDING.MARKETS.INDICES_DESC'})}
                </p>
              </div>
            </div>
            <div className='col-lg-4 col-md-6 col-12'>
              <div className='service-card'>
                <div className='service-icon'>
                  <img
                    src={toAbsoluteUrl('/media/illustrations/energy/sharesNew.png')}
                    alt={intl.formatMessage({id: 'LANDING.MARKETS.SHARES_TITLE'})}
                  />
                </div>
                <h5 className='service-title'>{intl.formatMessage({id: 'LANDING.MARKETS.SHARES_TITLE'})}</h5>
                <p className='service-description'>
                  {intl.formatMessage({id: 'LANDING.MARKETS.SHARES_DESC'})}
                </p>
              </div>
            </div>
            <div className='col-lg-4 col-md-6 col-12'>
              <div className='service-card'>
                <div className='service-icon'>
                  <img
                    src={toAbsoluteUrl('/media/illustrations/energy/commoditiesNew.png')}
                    alt={intl.formatMessage({id: 'LANDING.MARKETS.COMMODITY_TITLE'})}
                  />
                </div>
                <h5 className='service-title'>{intl.formatMessage({id: 'LANDING.MARKETS.COMMODITY_TITLE'})}</h5>
                <p className='service-description'>
                  {intl.formatMessage({id: 'LANDING.MARKETS.COMMODITY_DESC'})}
                </p>
              </div>
            </div>
            <div className='col-lg-4 col-md-6 col-12'>
              <div className='service-card'>
                <div className='service-icon'>
                  <img
                    src={toAbsoluteUrl('/media/illustrations/energy/cryptoNew.png')}
                    alt={intl.formatMessage({id: 'LANDING.MARKETS.CRYPTO_TITLE'})}
                  />
                </div>
                <h5 className='service-title'>{intl.formatMessage({id: 'LANDING.MARKETS.CRYPTO_TITLE'})}</h5>
                <p className='service-description'>
                  {intl.formatMessage({id: 'LANDING.MARKETS.CRYPTO_DESC'})}
                </p>
              </div>
            </div>
            <div className='col-lg-4 col-md-6 col-12'>
              <div className='service-card'>
                <div className='service-icon'>
                  <img
                    src={toAbsoluteUrl('/media/illustrations/energy/etfsNew.png')}
                    alt={intl.formatMessage({id: 'LANDING.MARKETS.ETF_TITLE'})}
                  />
                </div>
                <h5 className='service-title'>{intl.formatMessage({id: 'LANDING.MARKETS.ETF_TITLE'})}</h5>
                <p className='service-description'>
                  {intl.formatMessage({id: 'LANDING.MARKETS.ETF_DESC'})}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* end::markets Section */}

      {/* begin::Rewards Section */}
      <section className='rewards-section py-20'>
        <div className='container'>
          <div className='text-center mb-6'>
            <h2 className='mb-3 section-title'>{intl.formatMessage({id: 'LANDING.REWARDS.TITLE'})}</h2>
            <p className='text-gray-600 text-center fs-5 section-desc'>
              {intl.formatMessage({id: 'LANDING.REWARDS.DESC'})}
            </p>
          </div>
          <div className='row justify-content-center g-4 g-md-5'>
            {/* Card 1 */}
            <div className='col-12 col-md-6 col-lg-4'>
              <div
                className='reward-card p-6'
                style={{
                  backgroundImage: `url(${toAbsoluteUrl(
                    '/media/illustrations/energy/original1.webp'
                  )})`,
                }}
              >
                <div className='reward-card-content'>
                  <h3 className='reward-card-title'>{intl.formatMessage({id: 'LANDING.REWARDS.WELCOME_TITLE'})}</h3>
                  <p className='reward-card-desc'>
                    {intl.formatMessage({id: 'LANDING.REWARDS.WELCOME_DESC'})}
                  </p>
                </div>
              </div>
            </div>
            {/* Card 2 */}
            <div className='col-12 col-md-6 col-lg-4'>
              <div
                className='reward-card p-6'
                style={{
                  backgroundImage: `url(${toAbsoluteUrl(
                    '/media/illustrations/energy/original2.webp'
                  )})`,
                }}
              >
                <div className='reward-card-content'>
                  <h3 className='reward-card-title'>{intl.formatMessage({id: 'LANDING.REWARDS.INVITE_TITLE'})}</h3>
                  <p className='reward-card-desc'>
                    {intl.formatMessage({id: 'LANDING.REWARDS.INVITE_DESC'})}
                  </p>
                </div>
              </div>
            </div>
            {/* Card 3 */}
            <div className='col-12 col-md-6 col-lg-4'>
              <div
                className='reward-card p-6'
                style={{
                  backgroundImage: `url(${toAbsoluteUrl(
                    '/media/illustrations/energy/original3.webp'
                  )})`,
                }}
              >
                <div className='reward-card-content'>
                  <h3 className='reward-card-title'>{intl.formatMessage({id: 'LANDING.REWARDS.CASHBACK_TITLE'})}</h3>
                  <p className='reward-card-desc'>
                    {intl.formatMessage({id: 'LANDING.REWARDS.CASHBACK_DESC'})}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* end::Rewards Section */}

      {/* begin::Truth Section */}
      <section className='truth-section py-20'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-lg-6'>
              <h2 className='section-title text-dark mb-4'>{intl.formatMessage({id: 'LANDING.TRUTH.TITLE'})}</h2>
              <h3 className='fw-bold text-primary mb-4'>{intl.formatMessage({id: 'LANDING.TRUTH.SUBTITLE'})}</h3>
              <ul className='fs-5 mb-4 lh-lg' style={{paddingRight: 0}}>
                <li>
                  <img
                    src={toAbsoluteUrl('/media/illustrations/energy/watch.svg')}
                    alt={intl.formatMessage({id: 'LANDING.TRUTH.LI1'})}
                    style={{maxWidth: 19}}
                  />{' '}
                  {intl.formatMessage({id: 'LANDING.TRUTH.LI1'})}
                </li>
                <li>
                  <img
                    src={toAbsoluteUrl('/media/illustrations/energy/targetting.svg')}
                    alt={intl.formatMessage({id: 'LANDING.TRUTH.LI2'})}
                    style={{maxWidth: 19}}
                  />{' '}
                  {intl.formatMessage({id: 'LANDING.TRUTH.LI2'})}
                </li>
                <li className='mt-3 text-danger'>
                  {intl.formatMessage({id: 'LANDING.TRUTH.LI3'})}
                </li>
              </ul>
            </div>
            <div className='col-lg-6 text-center mb-5 mb-lg-0'>
              <img
                src={toAbsoluteUrl('/media/illustrations/energy/trading-is-hard-creative.png')}
                alt='واقعیت معامله‌گری'
                className='img-fluid'
                style={{maxHeight: 330}}
              />
            </div>
          </div>
        </div>
      </section>
      {/* end::Truth Section */}

      {/* begin::CopyTrading Success Section */}
      <section className='copy-success-section py-20'>
        <div className='container'>
          <div className='row align-items-center flex-lg-row-reverse'>
            <div className='col-lg-6'>
              <h2 className='section-title text-dark mb-4'>{intl.formatMessage({id: 'LANDING.COPY.TITLE'})}</h2>
              <p className='fs-5 mb-5'>
                {intl.formatMessage({id: 'LANDING.COPY.DESC'})}
              </p>
            </div>
            <div className='col-lg-6 text-center mb-5 mb-lg-0'>
              <img
                src={toAbsoluteUrl('/media/illustrations/energy/winner.png')}
                alt='کپی تریدینگ موفق'
                className='img-fluid'
                style={{maxHeight: 330}}
              />
            </div>
          </div>
        </div>
      </section>
      {/* end::CopyTrading Success Section */}

      {/* begin::Why Us Section */}
      <section className='why-us-section py-20'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-lg-6'>
              <h2 className='section-title mb-5 text-dark'>{intl.formatMessage({id: 'LANDING.WHY.TITLE'})}</h2>
              <ul className='fs-5 lh-lg'>
                <li>{intl.formatMessage({id: 'LANDING.WHY.LI1'})}</li>
                <li>{intl.formatMessage({id: 'LANDING.WHY.LI2'})}</li>
                <li>{intl.formatMessage({id: 'LANDING.WHY.LI3'})}</li>
                <li>{intl.formatMessage({id: 'LANDING.WHY.LI4'})}</li>
              </ul>
            </div>
            <div className='col-lg-6 text-center mb-5 mb-lg-0'>
              <img
                src={toAbsoluteUrl('/media/illustrations/energy/whyUs.png')}
                alt='چرا بیت سو بیت آکادمی'
                className='img-fluid'
                style={{maxHeight: 330}}
              />
            </div>
          </div>
        </div>
      </section>
      {/* end::Why Us Section */}

      {/* begin::How It Works Section */}
      <section className='how-it-works-section py-20'>
        <div className='container'>
          <div className='row align-items-center flex-lg-row-reverse'>
            <div className='col-lg-6'>
              <h2 className='section-title mb-5 text-dark'>{intl.formatMessage({id: 'LANDING.HOW.TITLE'})}</h2>
              <ol className='fs-5 lh-lg mb-10 list-styled-arabic'>
                <li>{intl.formatMessage({id: 'LANDING.HOW.LI1'})}</li>
                <li>{intl.formatMessage({id: 'LANDING.HOW.LI2'})}</li>
              </ol>
              <Link
                to='/auth/registration'
                className='custom-btn btn-custom-font btn-custom-color rounded-pill btn-lg px-7 me-2'
              >
                {intl.formatMessage({id: 'LANDING.HOW.CTA'})}
              </Link>
            </div>
            <div className='col-lg-6 text-center mb-5 mb-lg-0'>
              <img
                src={toAbsoluteUrl('/media/illustrations/energy/How-it-works-creative.png')}
                alt='نحوه کار پلتفرم'
                className='img-fluid'
                style={{maxHeight: 330}}
              />
            </div>
          </div>
        </div>
      </section>
      {/* end::How It Works Section */}

      {/* begin::Blog Section - commented out (not needed for now)
      <section className='blog-section py-20'>
        <div className='container'>
          <div className='text-center mb-6'>
            <h2 className='mb-3 section-title'>{intl.formatMessage({id: 'LANDING.BLOG.TITLE'})}</h2>
            <p className='text-gray-600 text-center fs-5 section-desc'>
              {intl.formatMessage({id: 'LANDING.BLOG.DESC'})}
            </p>
          </div>
          {loadingPosts ? (
            <div>{intl.formatMessage({id: 'LANDING.BLOG.LOADING'})}</div>
          ) : errorPosts ? (
            <div className='alert alert-danger'>{errorPosts}</div>
          ) : latestPosts.length === 0 ? (
            <div className='alert alert-info'>{intl.formatMessage({id: 'LANDING.BLOG.NO_POSTS'})}</div>
          ) : (
            <div className='row g-4'>
              {latestPosts.map((post) => (
                <div key={post.id} className='col-12 col-sm-6 col-lg-4'>
                  <BlogCard post={post} />
                </div>
              ))}
            </div>
          )}
          <div className='d-flex justify-content-center mt-5'>
            <Link to='/blog' className='btn btn-secondary btn-lg px-10'>
              {intl.formatMessage({id: 'LANDING.BLOG.SEE_ALL'})}
            </Link>
          </div>
        </div>
      </section>
      end::Blog Section */}

      {/* begin::Final CTA Section */}
      <section className='final-cta-section final-cta-section-index py-20'>
        <div className='container'>
          <div className='cta-card'>
            <div className='row align-items-center gy-5'>
              <div className='col-lg-12 text-center'>
                <img
                  src={toAbsoluteUrl('/media/illustrations/energy/become-trader-hero-banner.png')}
                  alt='عضویت رایگان معامله‌گر'
                  className='img-fluid'
                />
              </div>
              <div className='col-lg-12'>
                <div className='cta-content cta-content-index'>
                  <h2 className='cta-title mb-3 mt-5'>{intl.formatMessage({id: 'LANDING.FINAL_CTA.TITLE'})}</h2>
                  <p className='cta-description fs-5 mb-10'>
                    {intl.formatMessage({id: 'LANDING.FINAL_CTA.DESC'})}
                  </p>
                  <Link
                    to='/auth/registration'
                    className='custom-btn btn-custom-font btn-custom-color rounded-pill btn-lg px-7'
                  >
                    {intl.formatMessage({id: 'LANDING.HERO.CTA'})}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* end::Final CTA Section */}
    </>
  )
}
export {Index}
